import { KeycloakService } from "keycloak-angular";
import { environment } from "../../environments/environment";

export function initializeKeycloak(keycloak: KeycloakService) {
  return (): Promise<boolean> =>
    keycloak.init({
      config: {
        url: `${environment.keycloakUrl}`,
        realm: environment.keycloakRealm,
        clientId: environment.keycloakClientId
      },
      initOptions: {
        pkceMethod: "S256",
        redirectUri: environment.keycloakUrl,
        checkLoginIframe: false
      },
      loadUserProfileAtStartUp: true,
      enableBearerInterceptor: true,
      bearerPrefix: "Bearer",
      bearerExcludedUrls: ["opportunity/all-referral", "marketplace-opportunities"]
    });
}
